import { render, staticRenderFns } from "./AtlasFilesAllActivities.vue?vue&type=template&id=2864c13a"
import script from "./AtlasFilesAllActivities.vue?vue&type=script&lang=ts"
export * from "./AtlasFilesAllActivities.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports